import { useMutation, useQueryClient } from "@tanstack/react-query";
import boardService from "../api/boardService";

export const useUpdateBoardPermissions = () => {
  const { updateBoardPermissions } = boardService();

  return useMutation({
    mutationKey: ["update-board-permissions"],
    mutationFn: async ({ permissions }) => {
      const response = await updateBoardPermissions(permissions);
      return response.data;
    },
  });
};

export const useCreateBoardPermission = () => {
  const { createBoardPermission } = boardService();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["create-board-permission"],
    mutationFn: async ({ permission }) => {
      const response = await createBoardPermission(permission);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["get-user-board-permissions"],
      });
    },
    oneError: (error) => {
      console.error(error);
    },
  });
};

export const useUpdateBoard = () => {
  const { updateBoard } = boardService();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["update-board"],
    mutationFn: async ({ board }) => {
      const response = await updateBoard(board);
      return response.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["get-board", variables.board.id],
      });
    },
  });
};

export const useCreateBoard = () => {
  const { createBoard } = boardService();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["create-board"],
    mutationFn: async ({ board }) => {
      const response = await createBoard(board);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["get-boards-settings"],
      });
    },
  });
};

export const useDeleteBoard = () => {
  const { deleteBoard } = boardService();

  return useMutation({
    mutationKey: ["delete-board"],
    mutationFn: async ({ id }) => {
      const response = await deleteBoard(id);
      return response.data;
    },
  });
};

export const useRequestBoardAccess = () => {
  const { requestBoardAccess } = boardService();

  return useMutation({
    mutationKey: ["request-board-access"],
    mutationFn: async ({ boardIds }) => {
      const response = await requestBoardAccess({ boardIds });
      return response.data;
    },
  });
};
